import { createElement } from 'react';

import { RefractorElement, Text } from 'refractor';
import { Element } from 'refractor/lib/core';

import { CodeSegment } from '../types';

type Options = {
  key: string;
};

function isRefractorTextNode(node: RefractorElement | Text): node is Text {
  return node.type === 'text';
}

export default function astToReact(
  node: RefractorElement | Text,
  options: Options
): CodeSegment {
  if (isRefractorTextNode(node)) {
    return node.value;
  }

  // We have to assert this type here because for some reason TypeScript
  // is getting tripped up on the `Omit<Element, 'children'>` that is part of
  // the definition of `RefractorElement`.
  const n = node as Element;

  const { key } = options;
  // We have to narrow the type of `className` because we want to call `join`
  // in the next line of code. We're allowed to do this because `Properties`
  // specifically uses an array of strings for the `className` value.
  // See https://github.com/syntax-tree/hastscript#properties-1 for details.
  const classNamesList = (n.properties?.className as string[]) || [];
  const className = classNamesList.join(' ');
  const children = node.children.map((child, i) =>
    astToReact(child, { key: `${options.key}-child-${i}` })
  );

  return createElement(
    n.tagName,
    { ...n.properties, key, className },
    children
  );
}
